import React from "react";
import { Field, reduxForm } from "redux-form";
import { ReduxFormTextField } from "../../utils/ReduxFormTextField";
import { useSelector } from "react-redux";
import { getUserDetails } from "../../reducers/user";

const LoginForm = ({ handleSubmit }) => {
	const user = useSelector(getUserDetails);
	return (
		<form className="d-flex flex-column" onSubmit={handleSubmit}>
			{user?.error && <span style={{ color: "red", marginLeft: "4px", fontSize: '13px' }}>{'Wrong email-id or password'}</span>}
			<div className="mt-4">
				<Field
					component={ReduxFormTextField}
					label="User Name"
					name="username"
					className="form-control"
					type="text"
					placeholder="Enter username"
				/>
			</div>

			<div className="mt-4">
				<Field
					component={ReduxFormTextField}
					label="Password"
					name="password"
					className="form-control"
					type="password"
					placeholder="Enter Password"
				/>
			</div>

			<button
				className="btn btn-outline-primary mt-5"
				style={{ borderRadius: "25px" }}
				type="submit"
			>
				Submit
			</button>
		</form>
	);
};

export default reduxForm({
	form: "login",
	validate: values => {
		const errors = {};
		if (!values?.username || values?.username?.length === 0) {
			errors.username = "Required";
		}
		if (!values?.password || values?.password?.length === 0) {
			errors.password = "Required";
		}
		return errors;
	},
})(LoginForm);
